import React, { useState, useEffect } from 'react';
import { QRNormal } from 'react-qrbtf';
import PropTypes from 'prop-types';
import { wechatLoginInfoApi, wechatLoginCheckApi } from '@service';
import { message } from 'antd';
import './index.less';

const qrEx = 'http://cdnimg.yijiahaohuo.com/activity/9f2a5cf378e257dfe7a192b40c5acb64.png?imageslim';

const Scan = ({ callback: onFinish, userId = null, scanType = null }) => {
  const [qrData, setQrData] = useState();
  const [qrExpired, setQrExpired] = useState(false);
  const [count, setCount] = useState(0);

  async function fetchQr() {
    const param = userId ? { user_id: userId } : {};
    const param2 = scanType ? { scan_type: scanType } : {};
    const { flag, data } = await wechatLoginInfoApi({ ...param, ...param2 });

    flag === 200 && setQrData(data);
  }

  useEffect(() => {
    fetchQr();
  }, [userId]);

  useEffect(() => {
    const timer = setInterval(() => {
      const run = async () => {
        if (qrData && !qrExpired) {
          const param = userId ? { token: qrData.token, user_id: userId } : { token: qrData.token };
          const param2 = scanType ? { scan_type: scanType } : {};

          const { flag, data, msg } = await wechatLoginCheckApi({ ...param, ...param2 });

          if (flag === 200) {
            clearInterval(timer);
            onFinish(data);
          } else if (flag === 400) {
            clearInterval(timer);
            message.warning('您还未绑定微信，请先用账号密码登录后进行绑定~');
          } else if (flag === 401) {
            message.warning(msg);
          }
        }
      };

      setCount(x => x + 1);
      run();
    }, 1500);

    return () => {
      clearInterval(timer);
    };
  }, [qrData, qrExpired, userId]);

  useEffect(() => {
    count > 80 && setQrExpired(true);
  }, [count]);

  const refresh = () => {
    setCount(0);
    fetchQr();
    setQrExpired(false);
  };

  return (
    <div className="qr-box">
      {qrData && qrExpired && (
        <div className="qrcode-wrap">
          <img src={qrEx} alt="" onClick={refresh} />
          <p>二维码已过期，请点击图片刷新二维码</p>
        </div>
      )}
      {qrData && !qrExpired && (
        <div className="qrcode-wrap">
          <QRNormal value={qrData.url} />
          <p>请使用微信扫码</p>
        </div>
      )}
    </div>
  );
};

Scan.propTypes = {
  callback: PropTypes.func,
};

export default Scan;
